<template>
    <div class="rkld">
        <div class="rkldRight">
            <div class="rkldRightContent">
                <!-- tabs导航 -->
                <el-tabs v-model="editableTabsValue" type="card">
                    <el-tab-pane label="服务人员管理" name="1">
                        <!--搜索框-->
                        <div class="searchTj">
                            <div class="searchTjHead">
                                <span>查询条件</span>
                                <!-- <el-button
                  style="float: right; padding: 3px 0; color: #000"
                  type="text"
                  @click.native="Resert"
                >
                  <i class="el-icon-refresh"></i>
                  刷新页面
                </el-button> -->
                                <i
                                    class="searchDomw"
                                    @click="searchValue = !searchValue"
                                    :class="
                                        searchValue == true
                                            ? 'el-icon-arrow-up'
                                            : 'el-icon-arrow-down'
                                    "
                                ></i>
                            </div>
                            <el-form
                                :model="form"
                                class="searchTjContent"
                                v-show="searchValue"
                            >
                                <div class="searchTjContentDiv">
                                    <span class="searchTjContentDivSpan"
                                        >姓名</span
                                    >
                                    <el-input
                                        v-model="form.personName"
                                        placeholder="请输入"
                                        class="searchTjContentDivInput"
                                    ></el-input>
                                </div>
                                <div
                                    class="searchTjContentDiv"
                                    v-show="searchValue"
                                >
                                    <el-button
                                        type="primary"
                                        class="searchBtns"
                                        @click="query"
                                        >查询
                                    </el-button>
                                </div>
                                <div
                                    class="searchTjContentDiv"
                                    v-show="searchValue"
                                >
                                    <el-button
                                        type="info"
                                        class="resetReach"
                                        @click="resert"
                                        >重置
                                    </el-button>
                                </div>
                                <!-- <div class="arrowDown" @click="showSearch" style="color: #000">
                  <i class="el-icon-arrow-down"></i>
                </div> -->
                            </el-form>
                        </div>
                        <!--功能模块-->
                        <div class="searchButtonDiv" v-show="quanbu">
                            <div class="searchButtonDivLeft">
                                <el-button-group>
                                    <el-button
                                        icon="el-icon-plus"
                                        class="openBtns"
                                        type="success"
                                        @click="handleClick('新增')"
                                        >新增
                                    </el-button>
                                    <el-button
                                        icon="el-icon-delete"
                                        type="danger"
                                        @click="batchDelete"
                                        >批量删除
                                    </el-button>
                                    <el-button
                                        icon="el-icon-s-custom"
                                        style="background: #53afca"
                                        type="danger"
                                        @click="showDialog('职位类型管理')"
                                        >职位类型管理
                                    </el-button>
                                    <el-button
                                        icon="el-icon-user-solid"
                                        type="danger"
                                        style="background: #799abc"
                                        @click="showDialog('部门管理')"
                                        >部门管理
                                    </el-button>
                                </el-button-group>
                            </div>
                            <!-- 筛选按钮 -->
                            <div class="searchButtonDiveRight">
                                <el-button-group>
                                    <el-button
                                        type="primary"
                                        icon="el-icon-refresh"
                                        class="dropRests"
                                        @click="resertTable"
                                    ></el-button>
                                    <!-- <el-button type="primary"> -->
                                    <el-dropdown
                                        class="dropdown"
                                        trigger="click"
                                        :hide-on-click="false"
                                    >
                                        <span class="el-dropdown-link">
                                            <i
                                                class="
                                                    el-icon-s-grid
                                                    el-icon--right
                                                "
                                                style="color: #fff"
                                            ></i>
                                            <i
                                                class="
                                                    el-icon-arrow-down
                                                    el-icon--right
                                                "
                                            ></i>
                                        </span>
                                        <el-dropdown-menu slot="dropdown">
                                            <el-dropdown-item>
                                                <template>
                                                    <el-checkbox-group
                                                        v-model="checkList"
                                                        :min="1"
                                                        @change="tableShow"
                                                    >
                                                        <el-checkbox
                                                            label="序号"
                                                            >序号</el-checkbox
                                                        >
                                                        <br />
                                                        <el-checkbox
                                                            label="姓名"
                                                            >姓名</el-checkbox
                                                        >
                                                        <br />
                                                        <el-checkbox
                                                            label="身份证号"
                                                            >身份证号</el-checkbox
                                                        >
                                                        <br />
                                                        <el-checkbox
                                                            label="联系方式"
                                                            >联系方式</el-checkbox
                                                        >
                                                        <br />
                                                        <el-checkbox
                                                            label="职位类型"
                                                            >职位类型</el-checkbox
                                                        >
                                                        <br />
                                                        <el-checkbox
                                                            label="创建时间"
                                                            >创建时间</el-checkbox
                                                        >
                                                        <br />
                                                        <el-checkbox
                                                            label="操作"
                                                            >操作</el-checkbox
                                                        >
                                                        <br />
                                                    </el-checkbox-group>
                                                </template>
                                            </el-dropdown-item>
                                        </el-dropdown-menu>
                                    </el-dropdown>
                                    <!-- </el-button> -->
                                </el-button-group>
                            </div>
                        </div>
                        <!--表单-->
                        <div class="addForm">
                            <el-table
                                ref="multipleTable"
                                :data="personDate"
                                tooltip-effect="dark"
                                @selection-change="handleSelectionChange"
                                :header-cell-style="{
                                    background: '#e6e6e6',
                                    color: '#000',
                                }"
                                border
                            >
                                <el-table-column
                                    type="selection"
                                    width="50"
                                    align="center"
                                    @selection-change="handleSelectionChange"
                                >
                                </el-table-column>
                                <el-table-column
                                    type="index"
                                    width="70"
                                    label="序号"
                                    align="center"
                                    v-if="no1"
                                    show-overflow-tooltip
                                ></el-table-column>
                                <el-table-column
                                    prop="personName"
                                    label="姓名"
                                    align="center"
                                    v-if="no2"
                                    show-overflow-tooltip
                                >
                                </el-table-column>
                                <el-table-column
                                    prop="personIdentity"
                                    label="身份证号"
                                    align="center"
                                    show-overflow-tooltip
                                    v-if="no3"
                                >
                                </el-table-column>
                                <el-table-column
                                    prop="personPhone"
                                    label="联系方式"
                                    align="center"
                                    width="200"
                                    show-overflow-tooltip
                                    v-if="no4"
                                >
                                </el-table-column>
                                <el-table-column
                                    prop="positionName"
                                    label="职位类型"
                                    width="200"
                                    align="center"
                                    show-overflow-tooltip
                                    v-if="no6"
                                >
                                </el-table-column>
                                <el-table-column
                                    prop="createDate"
                                    label="创建时间"
                                    width="200"
                                    align="center"
                                    show-overflow-tooltip
                                    v-if="no7"
                                >
                                </el-table-column>
                                <el-table-column
                                    label="操作"
                                    align="center"
                                    width="250px"
                                    v-if="no8"
                                >
                                    <template slot-scope="scope">
                                        <el-tooltip
                                            class="item"
                                            effect="dark"
                                            content="查看"
                                            placement="top-start"
                                        >
                                            <button
                                                style="color: #000"
                                                class="
                                                    iconfont
                                                    icon-chakan
                                                    tabBtn
                                                "
                                                @click="
                                                    handleClick(
                                                        '查看',
                                                        scope.row
                                                    )
                                                "
                                            ></button>
                                        </el-tooltip>
                                        <el-tooltip
                                            class="item"
                                            effect="dark"
                                            content="编辑"
                                            placement="top-start"
                                        >
                                            <button
                                                style="color: #000"
                                                class="
                                                    iconfont
                                                    icon-bianji3
                                                    tabBtn
                                                "
                                                @click="
                                                    handleClick(
                                                        '编辑',
                                                        scope.row
                                                    )
                                                "
                                            ></button>
                                        </el-tooltip>
                                        <el-tooltip
                                            class="item"
                                            effect="dark"
                                            content="删除"
                                            placement="top-start"
                                        >
                                            <button
                                                style="color: #000"
                                                class="
                                                    iconfont
                                                    icon-icon7
                                                    tabBtn
                                                "
                                                @click="deleteItem(scope.row)"
                                            ></button>
                                        </el-tooltip>
                                    </template>
                                </el-table-column>
                            </el-table>
                            <!-- 分页 -->
                            <el-pagination
                                @size-change="handleSizeChange"
                                @current-change="handleCurrentChange"
                                :current-page="currentPage"
                                :page-sizes="[10, 20, 50, 100]"
                                :page-size="10"
                                layout="total, sizes, prev, pager, next, jumper"
                                :total="total"
                            ></el-pagination>
                        </div>
                    </el-tab-pane>
                </el-tabs>
            </div>
        </div>
        <el-dialog :title="dialogTile" :visible.sync="visVisible" width="990px">
            <el-form
                ref="addform"
                :model="addform"
                :rules="addformRules"
                label-width="120px"
                size="mini"
            >
                <el-form-item label="姓名:" prop="staffId">
                    <el-select
                        v-model="addform.staffId"
                        filterable
                        remote
                        :disabled="
                            dialogTile === '查看' || dialogTile === '编辑'
                        "
                        ref="fuzzySearch"
                        style="width: 100%"
                        placeholder="请输入关键词"
                        :remote-method="remoteMethod"
                        @change="handleSelect"
                        @click.native="clearForm"
                        :loading="loading"
                        solt="empty"
                    >
                        <el-option
                            v-for="item in options"
                            :key="item.id"
                            :label="item.personName"
                            :value="item.id"
                        >
                        </el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="身份证号：" prop="personIdentity">
                    <el-select
                        v-model="addform.personIdentity"
                        filterable
                        remote
                        style="width: 100%"
                        placeholder="请输入关键词"
                        :disabled="
                            dialogTile === '查看' || dialogTile === '编辑'
                        "
                        :remote-method="remoteMethod1"
                        @change="handleSelect"
                        @click.native="clearForm1"
                        :loading="loading"
                    >
                        <el-option
                            v-for="item in options"
                            :key="item.id"
                            :label="item.personIdentity"
                            :value="item.id"
                        >
                        </el-option>
                    </el-select>
                </el-form-item>

                <el-form-item label="联系方式:" prop="personPhone">
                    <el-input
                        disabled
                        v-model="addform.personPhone"
                        placeholder="请输入"
                    ></el-input>
                </el-form-item>
                <el-form-item label="职位：" prop="personPosition">
                    <el-select
                        v-model="addform.personPosition"
                        placeholder="请选择"
                        style="width: 100%"
                        :disabled="dialogTile == '查看'"
                    >
                        <el-option
                            v-for="item in tableDate1"
                            :key="item.value"
                            :label="item.positionName"
                            :value="item.id"
                        >
                        </el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="部门：" prop="departmentId">
                    <el-select
                        v-model="addform.departmentId"
                        placeholder="请选择"
                        style="width: 100%"
                        :disabled="dialogTile == '查看'"
                    >
                        <el-option
                            v-for="item in departmentDate1"
                            :key="item.value"
                            :label="item.departmentName"
                            :value="item.id"
                        >
                        </el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="是否使用APP：" prop="nonUser">
                    <el-radio-group v-model="addform.nonUser">
                        <el-radio label="0">启用</el-radio>
                        <el-radio label="1">禁用</el-radio>
                    </el-radio-group>
                </el-form-item>
            </el-form>
            <div slot="footer" v-if="dialogTile !== '查看'">
                <el-button
                    type="primary"
                    size="small"
                    style="margin: 0 30px"
                    @click="saveadddata"
                    >保存
                </el-button>
                <el-button type="info" size="small" @click="clearadddata"
                    >关闭</el-button
                >
            </div>
        </el-dialog>

        <el-dialog
            :title="dialogTile1"
            :visible.sync="visVisible1"
            width="990px"
        >
            <div v-if="showType == '1'">
                <el-button
                    icon="el-icon-plus"
                    type="success"
                    style="margin-bottom: 20px"
                    @click.native="addshow('新增')"
                    >新增
                </el-button>
                <el-table
                    ref="multipleTable1"
                    :data="tableDate"
                    tooltip-effect="dark"
                    :header-cell-style="{
                        background: '#e6e6e6',
                        color: '#000',
                    }"
                    border
                >
                    <el-table-column
                        type="index"
                        width="70"
                        prop="order"
                        label="序号"
                        align="center"
                        v-if="no1"
                        show-overflow-tooltip
                    ></el-table-column>
                    <el-table-column
                        prop="positionName"
                        label="职位类型名称"
                        align="center"
                        v-if="no2"
                        show-overflow-tooltip
                    >
                    </el-table-column>
                    <el-table-column
                        prop="positionStates"
                        label="状态"
                        align="center"
                        show-overflow-tooltip
                    >
                        <template slot-scope="scope">
                            <span v-if="scope.row.positionStates == 0"
                                >启用</span
                            >
                            <span v-if="scope.row.positionStates == 1"
                                >禁用</span
                            >
                        </template>
                    </el-table-column>
                    <el-table-column
                        prop="orgName"
                        label="所属机构"
                        align="center"
                        v-if="no3"
                        show-overflow-tooltip
                    >
                    </el-table-column>
                    <el-table-column
                        label="操作"
                        align="center"
                        width="250px"
                        v-if="no8"
                    >
                        <template slot-scope="scope">
                            <el-tooltip
                                class="item"
                                effect="dark"
                                content="编辑"
                                placement="top-start"
                            >
                                <button
                                    style="color: skyblue"
                                    class="iconfont icon-bianji3 tabBtn"
                                    @click="addshow('编辑', scope.row)"
                                ></button>
                            </el-tooltip>
                            <el-tooltip
                                class="item"
                                effect="dark"
                                content="删除"
                                placement="top-start"
                            >
                                <button
                                    style="color: skyblue"
                                    class="iconfont icon-icon7 tabBtn"
                                    @click="deleteItem1(scope.row)"
                                ></button>
                            </el-tooltip>
                        </template>
                    </el-table-column>
                </el-table>
                <el-pagination
                    @size-change="handleSizeChangepo"
                    @current-change="handleCurrentChangepo"
                    :current-page="currentPagepo"
                    :page-sizes="[10, 20, 50, 100]"
                    :page-size="10"
                    layout="total, sizes, prev, pager, next, jumper"
                    :total="totalpo"
                ></el-pagination>
            </div>

            <div v-if="showType == '2'">
                <el-button
                    icon="el-icon-plus"
                    type="success"
                    style="margin-bottom: 20px"
                    @click.native="addshow('新增')"
                    >新增
                </el-button>
                <el-table
                    ref="multipleTable1"
                    :data="departmentDate"
                    tooltip-effect="dark"
                    :header-cell-style="{
                        background: '#e6e6e6',
                        color: '#000',
                    }"
                    border
                >
                    <el-table-column
                        type="index"
                        width="70"
                        prop="order"
                        label="序号"
                        align="center"
                        show-overflow-tooltip
                    ></el-table-column>
                    <el-table-column
                        prop="departmentName"
                        label="部门名称"
                        align="center"
                        show-overflow-tooltip
                    >
                    </el-table-column>
                    <el-table-column
                        prop="departmentStates"
                        label="状态"
                        align="center"
                        show-overflow-tooltip
                    >
                        <template slot-scope="scope">
                            <span v-if="scope.row.departmentStates == 0"
                                >启用</span
                            >
                            <span v-if="scope.row.departmentStates == 1"
                                >禁用</span
                            >
                        </template>
                    </el-table-column>
                     <el-table-column
                        prop="orgName"
                        label="所属机构"
                        align="center"
                        v-if="no3"
                        show-overflow-tooltip
                    >
                    </el-table-column>
                    <el-table-column
                        label="操作"
                        align="center"
                        width="250px"
                        v-if="no8"
                    >
                        <template slot-scope="scope">
                            <el-tooltip
                                class="item"
                                effect="dark"
                                content="编辑"
                                placement="top-start"
                            >
                                <button
                                    style="color: skyblue"
                                    class="iconfont icon-bianji3 tabBtn"
                                    @click="addshow1('编辑', scope.row)"
                                ></button>
                            </el-tooltip>
                            <el-tooltip
                                class="item"
                                effect="dark"
                                content="删除"
                                placement="top-start"
                            >
                                <button
                                    style="color: skyblue"
                                    class="iconfont icon-icon7 tabBtn"
                                    @click="deleteItem2(scope.row)"
                                ></button>
                            </el-tooltip>
                        </template>
                    </el-table-column>
                </el-table>
                <el-pagination
                    @size-change="handleSizeChangede"
                    @current-change="handleCurrentChangede"
                    :current-page="currentPagede"
                    :page-sizes="[10, 20, 50, 100]"
                    :page-size="10"
                    layout="total, sizes, prev, pager, next, jumper"
                    :total="totalde"
                ></el-pagination>
            </div>
        </el-dialog>
        <el-dialog
            :title="dialogTitle2"
            :visible.sync="visVisible2"
            width="990px"
        >
            <div v-if="showType == 1">
                <el-form
                    ref="addform"
                    :model="addform"
                    :rules="addRules"
                    label-width="130px"
                    size="mini"
                >
                    <el-form-item label="职位类型名称：" prop="positionName">
                        <el-input
                            :disabled="dialogTile == '查看'"
                            v-model="addform.positionName"
                            placeholder="请输入"
                        ></el-input>
                    </el-form-item>
                    <el-form-item label="状态：" prop="positionStates">
                        <el-radio-group v-model="addform.positionStates">
                            <el-radio label="0">启用</el-radio>
                            <el-radio label="1">禁用</el-radio>
                        </el-radio-group>
                    </el-form-item>
                </el-form>
            </div>
            <div v-if="showType == 2">
                <el-form
                    ref="addform"
                    :model="addform"
                    :rules="formRules"
                    label-width="110px"
                    size="mini"
                >
                    <el-form-item label="部门名称：" prop="departmentName">
                        <el-input
                            :disabled="dialogTile == '查看'"
                            v-model="addform.departmentName"
                            placeholder="请输入"
                        ></el-input>
                    </el-form-item>
                    <el-form-item label="状态：" prop="departmentStates">
                        <el-radio-group v-model="addform.departmentStates">
                            <el-radio label="0">启用</el-radio>
                            <el-radio label="1">禁用</el-radio>
                        </el-radio-group>
                    </el-form-item>
                </el-form>
            </div>
            <div slot="footer">
                <el-button type="primary" @click="save">确定</el-button>
                <el-button @click="visVisible2 = false">取消</el-button>
            </div>
        </el-dialog>
    </div>
</template>
<script>
import common from "../../utils/common.js"
import request from "@/utils/request.js"
import { post, get } from "@/api/requrestHttp.js"
import baseURL from "@/api/baseURL"
import { personPhone } from "@/views/elderManage/util.js"

export default {
    data() {
        return {
            orgLevels: "",
            defaultProps: {
                children: "children",
                label: "label",
            },
            orgList: [],
            arrOrgList: [],
            // 表单验证
            addformRules: {
                staffId: [
                    { required: true, message: "请输入姓名", trigger: "blur" },
                ],
                // orgName: [{ required: true, message: "请选择组织机构", trigger: "change" }],
                personIdentity: [
                    {
                        required: true,
                        message: "请输入身份证号",
                        trigger: "blur",
                    },
                    {
                        pattern:
                            /(^[1-9]\d{5}(18|19|([23]\d))\d{2}((0[1-9])|(10|11|12))(([0-2][1-9])|10|20|30|31)\d{3}[0-9Xx]$)|(^[1-9]\d{5}\d{2}((0[1-9])|(10|11|12))(([0-2][1-9])|10|20|30|31)\d{2}$)/,
                        message: "证件号码格式有误！",
                        trigger: "blur",
                    },
                ],
                personPhone: [
                    {
                        required: true,
                        message: "请输入手机号",
                        trigger: "blur",
                    },
                    {
                        pattern: /^1[3|4|5|6|7|8|9]\d{9}$/,
                        message: "手机号码格式有误！",
                        trigger: "blur",
                    },
                ],
                // personPhone: [{ required: true, message: "请输入联系方式", trigger: "blur" }],
                personPosition: [
                    {
                        required: true,
                        message: "请选择职位",
                        trigger: "change",
                    },
                ],
                departmentId: [
                    {
                        required: true,
                        message: "请选择部门",
                        trigger: "change",
                    },
                ],
                nonUser: [
                    {
                        required: true,
                        message: "请选择是否启用APP",
                        trigger: "change",
                    },
                ],
            },
            addRules: {
                positionName: [
                    {
                        required: true,
                        message: "请输入职位类型名称",
                        trigger: "blur",
                    },
                ],
                positionStates: [
                    {
                        required: true,
                        message: "请选择状态",
                        trigger: "change",
                    },
                ],
            },
            formRules: {
                departmentName: [
                    {
                        required: true,
                        message: "请输入部门名称",
                        trigger: "blur",
                    },
                ],
                departmentStates: [
                    {
                        required: true,
                        message: "请选择状态",
                        trigger: "change",
                    },
                ],
            },
            selectedData: [],
            actionUrl:
                baseURL + "/jjyl/controller/uploadController/info/uploadPhoto",
            showType: 0,
            showtext: true,
            visVisible: false,
            visVisible1: false,
            visVisible2: false,
            dialogTile1: "",
            dialogTitle2: "",
            // 筛选功能按钮初始值
            checkList: [
                "序号",
                "姓名",
                "身份证号",
                "联系方式",
                "职位类型",
                "创建时间",
                "操作",
            ],
            quanbu: true,

            currentPage: 1, //默认展示第一页
            currentPagepo: 1, //默认展示第一页
            currentPagede: 1, //默认展示第一页
            total: 0, //总数据
            totalpo: 0, //总数据
            totalde: 0, //总数据
            searchValue: true,
            editableTabsValue: "1",
            editableTabs: [
                {
                    title: "人员信息",
                    name: "1",
                },
            ],
            personDate: [],
            tableDate: {
                positionName: "",
            },
            tableDate1: [],
            departmentDate: [],
            departmentDate1: [],
            pageNo: 1,
            pageSize: 10,
            pagepostConfig: {
                pageSize: 10,
                pageNo: 1,
            },
            pagedepartConfig: {
                pageSize: 10,
                pageNo: 1,
            },
            form: {
                personName: "",
                idCode: "",
                linkPhone: "",
                gridCode: "",
                pageNo: 1,
                pageSize: 10,
            },
            dialogTile: "",
            dialogImageUrl1: "",
            dialogVisible1: false,
            dialogImageUrl2: "",
            dialogVisible2: false,
            // 筛选功能按钮控制列表是否隐藏初始状态
            no1: true,
            no2: true,
            no3: true,
            no4: true,
            no5: true,
            no6: true,
            no7: true,
            no8: true,
            addform: {
                personName: "",
                positionName: "",
                positionStates: "",
                personIdentity: "",
                orgName: "",
                personPhone: "",
                personPosition: "",
                qujiId: "",
                shengjiId: "",
                shijiId: "",
                stationId: "",
                shequjiId: "",
                nonUser: "",
                departmentId: "",
                departmentName: "",
            },
            loading: false,
            options: [],
        }
    },
    inject: ["reload"], //注入
    created() {
        this.getOrg()
        this.showlist()
        this.positionlist()
        this.departmentlist()
    },
    methods: {
        getchangeList(query, query1) {
            this.$http
                .request({
                    url: "/ypt/admin/serviceStaff/info/findList",
                    method: "POST",
                    data: {
                        pageNo: 1,
                        pageSize: -1,
                        personName: query,
                        personIdentity: query1,
                    },
                })
                .then((res) => {
                    if (res.code == 200) {
                        if (res.content != null) {
                            this.options = res.content.list
                        } else {
                            this.options = []
                        }
                        this.loading = false
                    }
                })
        },
        remoteMethod(query) {
            if (query !== "") {
                this.loading = true
                this.getchangeList(query, "")
            } else {
                this.options = []
            }
        },
        remoteMethod1(query) {
            if (query !== "") {
                this.loading = true
                this.getchangeList("", query)
            } else {
                this.options = []
            }
        },

        async handleSelect(val) {
            let item = {}
            this.options.forEach((item) => {
                if (item.id == val) {
                    this.formData = JSON.parse(JSON.stringify(item))
                    console.log(item)
                    this.formData.staffId = val
                    this.$set(this.addform, "personName", item.personName)
                    this.$set(
                        this.addform,
                        "personIdentity",
                        item.personIdentity
                    )
                    this.$set(this.addform, "personPhone", item.personPhone)
                }
            })
        },
        //监控姓名是否为空
        clearForm(val) {
            if (val) {
                if (this.dialogTitle == "新增") {
                    this.$set(this.formData, "staffId", "")
                    this.addform.personName = ""
                    this.addform.personPhone = ""
                    this.addform.personIdentity = ""
                }
            }
        },
        //监控姓名是否为空
        clearForm1(val) {
            if (val) {
                if (this.dialogTitle == "新增") {
                    this.$set(this.formData, "staffId", "")
                    this.addform.personName = ""
                    this.addform.personPhone = ""
                    this.addform.personIdentity = ""
                }
            }
        },
        loopNode(node, arr) {
            if (node.parent == null) {
                return arr
            } else {
                arr.push(node.data.orgId)
                this.loopNode(node.parent, arr)
            }
        },
        handleEditNodeClick(data, node) {
            const clickNode = this.$refs.tree.getNode(node)
            const arr = []
            this.loopNode(clickNode, arr)
            this.arrOrgList = arr
            let obj = common.organization(this.arrOrgList)
            this.$set(this.addform, "orgId", data.orgId)
            this.$set(this.addform, "parentId", data.parentId)
            this.$set(this.addform, "orgType", data.orgType)
            this.$set(this.addform, "orgName", data.label)
            this.$set(this.addform, "qujiId", obj.qujiId)
            this.$set(this.addform, "shengjiId", obj.shengjiId)
            this.$set(this.addform, "shijiId", obj.shijiId)
            this.$set(this.addform, "stationId", obj.stationId)
            this.$set(this.addform, "shequjiId", obj.shequjiId)
            this.$refs["selectBoxRef"].handleClose()
        },
        //获取组织机构
        getOrg() {
            this.$http
                .request({
                    url: "/rbac/admin/org/info/OrgTreelist",
                    method: "POST",
                    data: { isValid: 1 },
                })
                .then((res) => {
                    if (res.code === 200) {
                        for (let i in res.content) {
                            if (res.content[i].orgType == "1") {
                                this.orgList.push(res.content[i])
                            }
                            this.orgLevels = res.content[0].orgLevel
                        }
                    }
                })
        },
        // 筛选功能按钮点击事件
        tableShow() {
            if (this.checkList.length > 0) {
                this.no1 =
                    this.checkList.findIndex((obj) => obj === "序号") !== -1
                this.no2 =
                    this.checkList.findIndex((obj) => obj === "姓名") !== -1
                this.no3 =
                    this.checkList.findIndex((obj) => obj === "身份证号") !== -1
                this.no4 =
                    this.checkList.findIndex((obj) => obj === "联系方式") !== -1
                this.no6 =
                    this.checkList.findIndex((obj) => obj === "职位类型") !== -1
                this.no7 =
                    this.checkList.findIndex((obj) => obj === "创建时间") !== -1
                this.no8 =
                    this.checkList.findIndex((obj) => obj === "操作") !== -1
            }
        },
        // 新增
        handleClick(type, date) {
            this.visVisible = true
            this.dialogTile = type
            this.topositionlist()
            this.todepartmentlist()
            this.resetForm("addform")
            switch (type) {
                case "新增":
                    this.addform.personName = ""
                    this.addform.personIdentity = ""
                    this.addform.orgName = ""
                    this.addform.personPhone = ""
                    this.addform.departmentId = ""
                    this.addform.nonUser = ""
                    break
                case "查看":
                    this.look(date)
                    break
                case "编辑":
                    this.look(date)
                    break
            }
        },
        // 职位类型
        showDialog(type) {
            this.visVisible1 = true
            this.dialogTile1 = type
            switch (type) {
                case "职位类型管理":
                    this.positionlist()
                    this.showType = 1
                    break
                case "部门管理":
                    this.departmentlist()
                    this.showType = 2
                    break
            }
        },
        // 新增产品
        addshow(type, date) {
            this.visVisible2 = true
            this.dialogTitle2 = type
            switch (type) {
                case "新增":
                    this.resetForm("addform")
                    break
                case "编辑":
                    this.look1(date)
                    break
                default:
                    break
            }
        },
        addshow1(type, date) {
            this.visVisible2 = true
            this.dialogTitle2 = type
            switch (type) {
                case "新增":
                    break
                case "编辑":
                    this.look2(date)
                    break
                default:
                    break
            }
        },
        clearadddata() {
            this.visVisible = false
        },
        //每页请求数据
        handleSizeChange(val) {
            this.pageSize = val
            this.showlist()
            this.$message({
                message: `每页请求${val}条数据成功`,
                type: "success",
            })
        },
        //请求第几数据
        handleCurrentChange(val) {
            this.pageNo = val
            this.showlist()
            this.$message({
                message: `请求第${val}页数据成功`,
                type: "success",
            })
        },
        //每页请求数据
        handleSizeChangepo(val) {
            this.pagepostConfig.pageSize = val
            this.positionlist()
            this.showType = 1
            this.$message({
                message: `每页请求${val}条数据成功`,
                type: "success",
            })
        },
        //请求第几数据
        handleCurrentChangepo(val) {
            this.pagepostConfig.pageNo = val
            this.positionlist()
            this.showType = 1
            this.$message({
                message: `请求第${val}页数据成功`,
                type: "success",
            })
        },
        //每页请求数据
        handleSizeChangede(val) {
            this.pagedepartConfig.pageSize = val
            this.departmentlist()
            this.showType = 2
            this.$message({
                message: `每页请求${val}条数据成功`,
                type: "success",
            })
        },
        //请求第几数据
        handleCurrentChangede(val) {
            this.pagedepartConfig.pageNo = val
            this.departmentlist()
            this.showType = 2
            this.$message({
                message: `请求第${val}页数据成功`,
                type: "success",
            })
        },
        handleClose(key, keyPath) {
            console.log(key, keyPath)
        },
        handleTabsEdit(targetName, action) {
            this.showlist(e)
        },
        showSearch() {
            this.searchValue = !this.searchValue
        },

        // 职位 start
        // 列表
        async positionlist() {
            this.tableDate = []
            let obj = common.organization(this.arrOrgList, this.orgLevels)
            let params = {
                pageNo: this.pagepostConfig.pageNo,
                pageSize: this.pagepostConfig.pageSize,
                webfrom: "2",
                qujiId: JSON.parse(localStorage.getItem("czUserInfo")).qujiId,
                shengjiId: JSON.parse(localStorage.getItem("czUserInfo"))
                    .shengjiId,
                shijiId: JSON.parse(localStorage.getItem("czUserInfo")).shijiId,
                stationId: JSON.parse(localStorage.getItem("czUserInfo"))
                    .stationId,
                shequjiId: JSON.parse(localStorage.getItem("czUserInfo"))
                    .shequjiId,
            }
            params = Object.assign({}, params)
            await request({
                url: "/jjyl/admin/position/info/findList",
                method: "POST",
                data: params,
            }).then((res) => {
                if (res.content != null) {
                    this.tableDate = res.content.list
                    this.totalpo = res.content.count
                } else {
                    this.tableDate = []
                }
            })
        },
        // 职位 start
        // 列表
        topositionlist() {
            this.tableDate = []
            let params = {
                pageNo: 1,
                pageSize: 100,
                positionStates: 0,
                webfrom: "2",
            }
            params = Object.assign({}, params)
            request({
                url: "/jjyl/admin/position/info/findList",
                method: "POST",
                data: params,
            }).then((res) => {
                if (res.content != null) {
                    this.tableDate1 = res.content.list
                } else {
                    this.tableDate1 = []
                }
            })
        },
        // 新增
        save() {
            if (this.showType == 1) {
                this.$refs.addform.validate((valid) => {
                    if (valid) {
                        let obj = common.organization(
                            this.arrOrgList,
                            this.orgLevels
                        )
                        let params = {
                            pageNo: this.pageNo,
                            pageSize: this.pageSize,
                            ...this.addform,
                            webfrom: "2",
                            // qujiId: obj.qujiId,
                            // shengjiId: obj.shengjiId,
                            // shijiId: obj.shijiId,
                            // stationId: obj.stationId,
                            // shequjiId:obj.shequjiId,
                            // orgName: obj.orgName,
                            // orgId: obj.orgId,
                            qujiId: JSON.parse(
                                localStorage.getItem("czUserInfo")
                            ).qujiId,
                            shengjiId: JSON.parse(
                                localStorage.getItem("czUserInfo")
                            ).shengjiId,
                            shijiId: JSON.parse(
                                localStorage.getItem("czUserInfo")
                            ).shijiId,
                            stationId: JSON.parse(
                                localStorage.getItem("czUserInfo")
                            ).stationId,
                            shequjiId: JSON.parse(
                                localStorage.getItem("czUserInfo")
                            ).shequjiId,
                        }
                        params = Object.assign({}, params)
                        request({
                            url: "/jjyl/admin/position/info/insert",
                            method: "POST",
                            data: params,
                        }).then((res) => {
                            console.log(res)
                            this.visVisible2 = false
                            this.positionlist()
                        })
                    }
                })
                // this.visVisible2 = false
            }
            if (this.showType == 2) {
                this.$refs.addform.validate((valid) => {
                    if (valid) {
                        let obj = common.organization(
                            this.arrOrgList,
                            this.orgLevels
                        )
                        let params = {
                            pageNo: this.pageNo,
                            pageSize: this.pageSize,
                            ...this.addform,
                            webfrom: "2",
                            // qujiId: obj.qujiId,
                            // shengjiId: obj.shengjiId,
                            // shijiId: obj.shijiId,
                            // stationId: obj.stationId,
                            // shequjiId:obj.shequjiId,
                            // orgName: obj.orgName,
                            // orgId: obj.orgId,
                            qujiId: JSON.parse(
                                localStorage.getItem("czUserInfo")
                            ).qujiId,
                            shengjiId: JSON.parse(
                                localStorage.getItem("czUserInfo")
                            ).shengjiId,
                            shijiId: JSON.parse(
                                localStorage.getItem("czUserInfo")
                            ).shijiId,
                            stationId: JSON.parse(
                                localStorage.getItem("czUserInfo")
                            ).stationId,
                            shequjiId: JSON.parse(
                                localStorage.getItem("czUserInfo")
                            ).shequjiId,
                        }
                        params = Object.assign({}, params)
                        request({
                            url: "/jjyl/admin/department/info/insert",
                            method: "POST",
                            data: params,
                        }).then((res) => {
                            this.visVisible2 = false
                            this.departmentlist()
                        })
                    }
                })
            }
        },
        // 查看
        async look1(date) {
            let params = {
                pageNo: this.pageNo,
                pageSize: this.pageSize,
                id: date.id,
            }
            params = Object.assign({}, params)
            await request({
                url: "/jjyl/admin/position/info/findById",
                method: "POST",
                data: params,
            }).then((res) => {
                this.addform = res.content
            })
        },
        // 删除
        deleteItem1(date) {
            this.$confirm("确认永久删除吗?", "提示", {
                confirmButtonText: "确定",
                cancelButtonText: "取消",
                type: "warning",
            }).then(() => {
                request({
                    url: "/jjyl/admin/position/info/deleteById",
                    method: "POST",
                    data: { id: date.id },
                }).then((res) => {
                    if (res.code === 200) {
                        this.positionlist()
                        this.$message({
                            message: "新增或编辑",
                            type: "success",
                        })
                    } else if (res.code === 201) {
                        this.$message({
                            message: "该职位关联服务人员，无法删除",
                            type: "error",
                        })
                    } else {
                        this.$message({
                            message: "新增或编辑失败",
                            type: "error",
                        })
                    }
                })
            })
        },
        // 职位 end
        // 部门 start
        // 列表
        todepartmentlist() {
            this.departmentDate1 = []
            let params = {
                pageNo: 1,
                pageSize: 100,
                webfrom: "2",
                departmentStates: 0,
            }
            params = Object.assign({}, params)
            request({
                url: "/jjyl/admin/department/info/findList",
                method: "POST",
                data: params,
            }).then((res) => {
                if (res.content != null) {
                    this.departmentDate1 = res.content.list
                    this.totalde = res.content.list.length
                } else {
                    this.departmentDate1 = []
                }
            })
        },
        // 列表
        async departmentlist() {
            this.departmentDate = []
            let params = {
                pageNo: this.pagedepartConfig.pageNo,
                pageSize: this.pagedepartConfig.pageSize,
                webfrom: "2",
                qujiId: JSON.parse(localStorage.getItem("czUserInfo")).qujiId,
                shengjiId: JSON.parse(localStorage.getItem("czUserInfo"))
                    .shengjiId,
                shijiId: JSON.parse(localStorage.getItem("czUserInfo")).shijiId,
                stationId: JSON.parse(localStorage.getItem("czUserInfo"))
                    .stationId,
                shequjiId: JSON.parse(localStorage.getItem("czUserInfo"))
                    .shequjiId,
            }
            params = Object.assign({}, params)
            await request({
                url: "/jjyl/admin/department/info/findList",
                method: "POST",
                data: params,
            }).then((res) => {
                if (res.content != null) {
                    this.departmentDate = res.content.list
                    this.totalde = res.content.list.length
                } else {
                    this.departmentDate = []
                }
            })
        },
        // 查看
        async look2(date) {
            let params = {
                pageNo: this.pageNo,
                pageSize: this.pageSize,
                id: date.id,
                qujiId: JSON.parse(localStorage.getItem("czUserInfo")).qujiId,
                shengjiId: JSON.parse(localStorage.getItem("czUserInfo"))
                    .shengjiId,
                shijiId: JSON.parse(localStorage.getItem("czUserInfo")).shijiId,
                stationId: JSON.parse(localStorage.getItem("czUserInfo"))
                    .stationId,
                shequjiId: JSON.parse(localStorage.getItem("czUserInfo"))
                    .shequjiId,
            }
            params = Object.assign({}, params)
            await request({
                url: "/jjyl/admin/department/info/findById",
                method: "POST",
                data: params,
            }).then((res) => {
                this.addform = res.content
            })
        },
        // 删除
        deleteItem2(date) {
            this.$confirm("确认永久删除吗?", "提示", {
                confirmButtonText: "确定",
                cancelButtonText: "取消",
                type: "warning",
            }).then(() => {
                request({
                    url: "/jjyl/admin/department/info/deleteById",
                    method: "POST",
                    data: { id: date.id },
                }).then((res) => {
                    this.departmentlist()
                    if (res.code === 200) {
                        this.$message({
                            message: "新增或编辑",
                            type: "success",
                        })
                    } else if (res.code === 201) {
                        this.$message({
                            message: "该职位关联服务人员，无法删除",
                            type: "error",
                        })
                    } else {
                        this.$message({
                            message: "新增或编辑失败",
                            type: "error",
                        })
                    }
                })
            })
        },
        // 部门 end
        //拿到列表数据
        async showlist(s) {
            let params = {
                pageNo: this.pageNo,
                pageSize: this.pageSize,
                webfrom: "2",
                personName: s === true ? "" : this.form.personName,
            }
            params = Object.assign({}, params)
            await request({
                url: "/jjyl/admin/person/info/findList",
                method: "POST",
                data: params,
            }).then((res) => {
                console.log(res)
                if (res.content != null) {
                    this.personDate = res.content.list
                    this.total = res.content.count
                } else {
                    this.personDate = []
                }
            })
        },
        // 查询
        query() {
            post("/jjyl/admin/person/info/findList", {
                pageNo: this.pageNo,
                pageSize: this.pageSize,
                webfrom: "2",
                ...this.form,
            }).then((res) => {
                if (res.content != null) {
                    this.personDate = res.content.list
                    this.total = res.content.count
                } else {
                    this.personDate = []
                }
            })
        },
        // 保存
        saveadddata() {
            if (this.dialogTile == "编辑") {
                this.addform.staffId = this.addform.lsId
            } else if (this.dialogTile == "新增") {
                this.addform.id = ""
            }
            this.$refs.addform.validate((valid) => {
                if (valid) {
                    let params = {
                        pageNo: this.pageNo,
                        pageSize: this.pageSize,
                        ...this.addform,
                        webfrom: "2",
                    }
                    params = Object.assign({}, params)
                    request({
                        url: "/jjyl/admin/person/info/insert",
                        method: "POST",
                        data: params,
                    }).then((res) => {
                        console.log(res)
                        if (res.code === 200) {
                            console.log(res)
                            this.visVisible = false
                            this.showlist()
                            if (res.content.nonUser == "0") {
                                console.log("000000")
                                let date = {
                                    id: res.content.id,
                                    name: res.content.personName,
                                    mobilePhone: res.content.personPhone,

                                    sche: 2,
                                }
                                console.log(date)
                                params = Object.assign({}, date)
                                request({
                                    url: "/jjyl/admin/person/info/insertServePerson",
                                    method: "POST",
                                    data: date,
                                }).then((res) => {
                                    this.visVisible = false
                                    this.showlist()
                                })
                            } else {
                                console.log("000000")
                                let date = {
                                    id: res.content.id,
                                    name: res.content.personName,
                                    mobilePhone: res.content.personPhone,
                                    delappPer: "1",
                                    sche: 2,
                                }
                                console.log(date)
                                params = Object.assign({}, date)
                                request({
                                    url: "/jjyl/admin/person/info/insertServePerson",
                                    method: "POST",
                                    data: date,
                                }).then((res) => {
                                    this.visVisible = false
                                    this.showlist()
                                })
                            }
                            // this.orgLevels=res.content[0].orgLevel
                        }
                    })
                }
            })
        },
        // 查看
        async look(date) {
            let params = {
                pageNo: this.pageNo,
                pageSize: this.pageSize,
                id: date.id,
                staffId: date.staffId,
            }
            params = Object.assign({}, params)
            await request({
                url: "/jjyl/admin/person/info/findById",
                method: "POST",
                data: params,
            }).then((res) => {
                console.log(res)
                this.addform = res.content
                this.addform.lsId = res.content.staffId
                this.addform.staffId = res.content.personName
            })
        },
        // 删除
        deleteItem(date) {
            this.$confirm("确认永久删除吗?", "提示", {
                confirmButtonText: "确定",
                cancelButtonText: "取消",
                type: "warning",
            }).then(() => {
                request({
                    url: "/jjyl/admin/person/info/deleteById",
                    method: "POST",
                    data: { id: date.id },
                }).then((res) => {
                    this.showlist()
                    this.$message({
                        type: "success",
                        message: "删除成功!",
                    })
                    this.departmentlist()
                    request({
                        url: "/jjyl/admin/person/info/insertServePerson",
                        method: "POST",
                        data: {
                            mobilePhone: date.personPhone,
                            delappPer: "1",
                            sche: 2,
                        },
                    }).then((res) => {
                        this.showlist()
                        this.$message({
                            type: "success",
                            message: "删除成功!",
                        })
                        this.departmentlist()
                    })
                })
            })
        },
        resert() {
            this.form = {}
            this.showlist()
        },
        // 表单刷新
        resertTable() {
            // this.form.personName = "";
            this.showlist(true)
            this.checkList = [
                "序号",
                "姓名",
                "身份证号",
                "联系方式",
                "职位类型",
                "创建时间",
                "操作",
            ]
            this.tableShow()
        },
        // 重置
        Resert() {
            this.reload()
        },
        handleSelectionChange(data) {
            this.selectedData = data
        },
        batchDelete() {
            var that = this
            var val = this.selectedData
            if (val.length > 0) {
                this.$confirm("确认永久删除吗?", "提示", {
                    confirmButtonText: "确定",
                    cancelButtonText: "取消",
                    type: "warning",
                })
                    .then(() => {
                        val.forEach(function (item, index) {
                            request({
                                url: "/jjyl/admin/person/info/deleteById",
                                method: "POST",
                                data: { id: item.id },
                            })
                        })
                    })
                    .then(() => {
                        this.showlist()
                        this.$message({
                            type: "success",
                            message: "删除成功!",
                        })
                    })
            } else {
                this.$confirm("请选择要删除的项。", "提示")
            }
            this.$refs.multipleTable.clearSelection()
        },
        // 表单重置
        resetForm(formName) {
            if (this.$refs[formName] !== undefined) {
                this.$refs[formName].resetFields()
            }
        },
    },
}
</script>
<style lang="less" scoped>
.rkld {
    display: flex;
    flex-direction: row;
    height: 100vh;
    overflow: hidden;
}

.rkldRight {
    flex: 1;
    height: 100%;
    width: calc(100% - 254px);
    background-color: #ffffff;
}

.rkldRightHeadRight {
    display: flex;
    flex-direction: row;
    align-items: center;
    margin-right: 15px;
}

.demo-form-inline {
    padding: 0 5%;
}

.btnform {
    text-align: center;
}

.rkldRightHeadRightRight {
    display: flex;
    flex-direction: row;
    align-items: center;
    position: relative;
    cursor: pointer;
    background: rgba(252, 254, 255, 1);
    border: 1px solid rgba(217, 217, 217, 1);
    border-radius: 19px;
    box-sizing: border-box;
    padding: 7px 20px;
    margin-left: 20px;
    color: #444;
    font-size: 12px;
}

.rkldRightHeadRightRight span {
    width: 1px;
    height: 20px;
    margin: 0 14px;
    background: #ccc;
    opacity: 0.6;
}

.rkldRightHeadRightRight div {
    display: flex;
    align-items: center;
}

.rkldRightContent {
    height: calc(100% - 70px);
    overflow-y: auto;
    margin: 20px;
}

.searchTj {
    display: flex;
    flex-direction: column;
    position: relative;
    background: #f1f2f6;
    box-shadow: 0 0 6px rgba(151, 151, 151, 0.16);
    overflow: hidden;
    border-radius: 4px;
    margin: 5px;
}

.searchTjHead {
    background: #fff;
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    align-items: center;
    font-size: 14px;
    color: rgb(0, 0, 0);
    border-color: rgb(217, 217, 217);
    padding: 6px 15px;
    border-top-left-radius: 3px;
    border-top-right-radius: 3px;
}

.searchTjContent {
    padding: 15px 20px 0px 5px;
    border: 1px solid rgb(217, 217, 217);
    display: flex;
    flex-direction: row;
    flex-wrap: wrap;
}

.searchTjContentDiv {
    display: flex;
    flex-direction: row;
    align-items: center;
    margin-left: 40px;
    margin-bottom: 10px;

    .el-button {
        border-radius: 4px;
    }
}

.searchTjContentDivSpan {
    min-width: 58px;
    margin-right: 20px;
    font-size: 14px;
}

.searchTjContentDivInput {
    width: 20%;
    min-width: 196px;
}

/deep/ .arrowDown {
    width: 28px;
    height: 28px;
    background: #edf2f0;
    display: flex;
    justify-content: center;
    align-items: center;
    position: absolute;
    left: 50%;
    bottom: -14px;
    transform: translate(-50%, 0px);
    border-radius: 50%;
    z-index: 2;
    cursor: pointer;
}

/deep/ .el-tabs__content {
    padding-bottom: 20px;
}

.searchButtonDiv {
    height: 54px;
    display: flex;
    margin-top: 14px;
    align-items: center;
    justify-content: space-between;
}

.searchButtonDivLeft {
    display: flex;
}

/deep/ .el-button {
    margin-left: 0px;
    border-radius: 0px;
    padding: 0px 8px !important;
    border: none;
    height: 30px;
}

.el-button-group /deep/ .el-button--warning:last-child {
    border-left-color: rgba(255, 255, 255, 0.5);
    border-top-right-radius: 4px;
    border-bottom-right-radius: 4px;
}

/deep/ .el-pagination {
    margin-top: 10px;
}

/deep/ .el-submenu__title i {
    color: #fff;
}

/deep/ .el-submenu__title {
    border-bottom: 1px solid #2c3342;
    background: rgb(55, 64, 79) !important;
}

/deep/ .el-submenu.is-active /deep/ .el-submenu__title {
    border-bottom: 1px solid rgb(55, 64, 79);
}

/deep/
    .el-tabs--card
    > .el-tabs__header
    /deep/
    .el-tabs__item.is-active.is-closable {
    color: #0e2d5f;
}

/deep/ .el-submenu {
    width: 234px !important;
}

/deep/ .tabBtn {
    margin: 0px;
}

.boontbtn {
    margin-top: 30px;
    display: flex;
    justify-content: center;
}

.searchButtonDivLeft {
    /deep/ .el-checkbox__input.is-checked + .el-checkbox__label {
        color: #000000;
    }

    /deep/ .el-button:first-of-type {
        border-top-left-radius: 4px;
        border-bottom-left-radius: 4px;
    }

    /deep/ .el-button:last-of-type {
        border-top-right-radius: 4px;
        border-bottom-right-radius: 4px;

        i,
        span {
            color: #fff;
        }
    }
}

/deep/ .el-checkbox__input.is-checked + .el-checkbox__label {
    color: #000000;
}

/* 用来设置当前页面element全局table 选中某行时的背景色*/
/deep/ .el-table__body tr.current-row > td {
    background-color: #fafad2 !important;
    color: #000;
}

/deep/ .el-table tbody tr:hover > td {
    background-color: #fafad2 !important;
}

/deep/ .el-dialog .el-dialog__header {
    border-bottom: 1px solid #e4e4e4;
}

// 弹框底部
/deep/ .el-dialog .el-dialog__footer {
    background-color: #f5f5f5;
}
</style>
